import { render, staticRenderFns } from "./goldsilveroutHistory.vue?vue&type=template&id=d2e7e6d2&scoped=true&"
import script from "./goldsilveroutHistory.vue?vue&type=script&lang=js&"
export * from "./goldsilveroutHistory.vue?vue&type=script&lang=js&"
import style0 from "./goldsilveroutHistory.vue?vue&type=style&index=0&id=d2e7e6d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e7e6d2",
  null
  
)

export default component.exports